import { render, staticRenderFns } from "./return-goods.vue?vue&type=template&id=ff7b1b62&scoped=true&"
import script from "./return-goods.vue?vue&type=script&lang=ts&"
export * from "./return-goods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7b1b62",
  null
  
)

export default component.exports